// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox_checkbox__KQ9_E","outer":"checkbox_outer__2vUB1","inner":"checkbox_inner__t1awG"};